import { CategoryFull } from 'modules/shared/modules/categories-shared/interfaces/category-full.interface';

const HEALTH_DEPARTMENT = 'a16';

const getPromotedText = (path: CategoryFull['path']): string | null => {
    if (path?.some(item => item?.category?.id === HEALTH_DEPARTMENT)) {
        return null;
    }

    return 'Promowana oferta:';
};

export default getPromotedText;
